import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './ui/CtaButton';
import { SectionHeading } from './ui/SectionHeading';
import { CHECKOUT_BASE, CHECKOUT_PRO } from '../constants/checkout';
const plans = [{
  badge: '📘',
  name: 'Pack Blanco Perfecto',
  includes: '1 tomo + 5 bonos',
  description: null as string | null,
  before: '$38.000',
  price: '$19.990',
  cta: 'Quiero mi pack',
  href: CHECKOUT_BASE,
  featured: false
}, {
  badge: '🏆',
  name: 'Pack + Blanco Perfecto PRO',
  includes: '1 tomo + 5 bonos + upsell PRO',
  description: 'Para barberos que quieren ser el referente del blanco premium en su zona.',
  before: '$52.000',
  price: '$27.990',
  cta: 'Quiero el pack completo',
  href: CHECKOUT_PRO,
  featured: true
}];
export function Pricing() {
  return <section id="planes" aria-label="Elegí tu pack" className="scroll-mt-24 border-b border-ink-700 bg-ink-900 py-16 sm:py-20" data-id="element-137" data-mp="3h9hejtdwnm1p">
      <div className="mx-auto w-full max-w-page px-5 sm:px-8" data-id="element-138" data-mp="3w08be0dy786o">
        <SectionHeading label="Elegí tu pack" title="💰 Dos formas de empezar hoy" align="center" data-id="element-139" data-mp="4t5m5eho7bz3" />

        <div className="mt-12 grid gap-6 lg:grid-cols-2" data-id="element-140" data-mp="9s8rz15h5m84">
          {plans.map((plan, i) => <motion.article key={plan.name} initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.45,
          delay: i * 0.1
        }} className={`relative flex flex-col border bg-ink-950 p-7 sm:p-9 ${plan.featured ? 'border-bone' : 'border-ink-700'}`} data-id="element-141" data-mp="erbmvsrqqc2d" data-mpi={i}>
              {plan.featured ? <span className="display absolute -top-3 left-7 bg-bone px-3 py-1 text-xs text-ink-950" data-id="element-142" data-mp="3rzy8wxpd6zwk">
                  ⭐ Más elegido
                </span> : null}

              <p className="text-2xl" aria-hidden="true" data-id="element-143" data-mp="2zfpxk4v36o3f">
                {plan.badge}
              </p>
              <h3 className="display mt-3 text-2xl text-bone sm:text-3xl" data-id="element-144" data-mp="2rf1v64amxm8d">{plan.name}</h3>
              <p className="mt-2 text-xs font-bold uppercase tracking-[0.18em] text-ice" data-id="element-145" data-mp="2mh8koz2au62a">
                {plan.includes}
              </p>
              {plan.description ? <p className="mt-4 text-sm leading-relaxed text-ash sm:text-base" data-id="element-146" data-mp="2w8min2elqxtb">
                  {plan.description}
                </p> : null}

              <div className="mt-8 flex flex-1 flex-col justify-end" data-id="element-147" data-mp="23j5s6aajlqzq">
                <p className="text-base font-semibold text-ash line-through" data-id="element-148" data-mp="23l0g7xh41z81">{plan.before}</p>
                <p className="display mt-1 text-5xl text-bone sm:text-6xl" data-id="element-149" data-mp="2ihhmiaag0nnq">
                  {plan.price} <span className="text-xl text-ash" data-id="element-150" data-mp="2dfio7etk8gxn">ARS</span>
                </p>
                <div className="mt-7" data-id="element-151" data-mp="3tu0mbrymouvg">
                  <CtaButton href={plan.href} variant={plan.featured ? 'solid' : 'outline'} size="md" data-id="element-152" data-mp="3tx6claizu2sr">
                    {plan.cta}
                  </CtaButton>
                </div>
                <p className="mt-4 text-center text-[11px] font-semibold uppercase tracking-[0.16em] text-ash" data-id="element-153" data-mp="5a9s2yj5m12s">
                  🔒 Pago seguro · 💳 Mercado Pago · ⚡ 5 min
                </p>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}